// redux/actions/services.js
import { instance } from "./instance";
import {
  GET_SERVICES_REQUEST,
  GET_SERVICES_SUCCESS,
  GET_SERVICES_FAILURE,
} from "./actionTypes";

export const fetchServices = () => async (dispatch) => {
  dispatch({ type: GET_SERVICES_REQUEST });
  try {
    const { data } = await instance.get("/services");
    dispatch({ type: GET_SERVICES_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: GET_SERVICES_FAILURE,
      payload: err.response?.data?.message || err.message,
    });
  }
};
